import React from "react";
import "./Admin.css";

const Admin = () => {
  return <div className="admin">In Progress...</div>;
};

export default Admin;
